import React from 'react';
import { Typography } from '@mui/material';
import { SAGE } from '../../theme';

const SectionHeader = ({ children, sx, ...props }) => (
  <Typography
    variant="overline"
    sx={{
      fontFamily: "'Outfit', sans-serif",
      fontSize: '0.6875rem',
      fontWeight: 600,
      color: SAGE[500],
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      ...sx,
    }}
    {...props}
  >
    {children}
  </Typography>
);

export default SectionHeader;
